/**
 * ModulF-Fachverfahren-Manifest. Beschreibt ein deploytes Fachverfahren.
 */
export const FACHVERFAHREN_MANIFEST = "Fachverfahren_Manifest_D";

/**
 * ModulF-Fachverfahren-Manifest. Beschreibt ein deploytes Fachverfahren.
 */
export const STAMMDATEN_MANIFEST = "Stammdaten_Manifest_D";

/**
 *Textbausteine Verfahren Document.
 */
export const TEXTBAUSTEINE_VERFAHREN_DOCUMENT = "Verfahren_D";

/**
 * Textbausteine Kategorien Readonly Document.
 */
export const TEXTBAUSTEINE_KATEGORIE_READONLY_DOCUMENT = "Kategorien_Readonly_D";

export const TEXTBAUSTEINE_KATEGORIE_DOCUMENT = "Kategorien_D";

export const TEXTBAUSTEINE_TEXT_DOCUMENT = "Text_D";
/**
 * Textbausteine Tree Document.
 */
export const TEXTBAUSTEINE_TREE = "Textbausteine_T";

/**
 * Textbausteine readonly Tree Document.
 */
export const TEXTBAUSTEINE_READONLY_TREE = "Textbausteine_Readonly_T";

export const TEXTBAUSTEINE_RELATIONSHIP_DOCUMENT = "Node_R";
